// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__38k_f","overflowing":"ReadFullNote_overflowing__1seXB"};